import { expValEquals } from '@confluence/feature-experiments';

export const scrollToHeader = (id: string | undefined) => {
	if (!id) return;
	const escapedId = id.replace(/[.:;*+?^$!@$^&~%{}()=/|[\]\\]/g, '\\$&');
	const pmodeContent = document.querySelector(`#presenter-mode-container ${escapedId}`);
	if (pmodeContent) {
		pmodeContent.scrollIntoView();
	}

	if (expValEquals('confluence_toc_nav_a11y', 'isEnabled', true)) {
		// Extract the id from the href (remove the # prefix if present)
		const targetId = id.startsWith('#') ? id.substring(1) : id;
		const decodedId = decodeURIComponent(targetId);

		// For normal page view, find the element by id
		const targetElement = document.getElementById(decodedId);
		if (targetElement) {
			// Move focus to the target element for screen reader accessibility
			targetElement.focus();
		}
	}
};
